export default {
    "fsm_messages": "FSM Mensajes",
    "fsm_routes": "FSM Rutas",
    "fsm_settings": "FSM Configuraciones"
};